import React, { useEffect, useState } from 'react';
import { FormControl } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import FieldNames from '../../../defaults/FieldNames.json';
import { useSelector } from 'react-redux';
import BasicTextField from './BasicTextField';
import Events from '../../../defaults/Events';

const theme = createTheme({
  overrides: {
    root:{
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: 'white',
        }
      }
    }
  },
});

const useStyles = makeStyles({
  notchedOutline: {
    borderColor: "red",
    borderWidth: 2,
  },
  root: {
    '&:hover $notchedOutline': {
       borderColor: 'red'
    },
    '&.Mui-focused $notchedOutline': {
      borderColor: 'red'
    }
  },
  notchedNotSavedOutline:  {
    borderColor: "gold",
    borderWidth: 2,
  },
  notsavedstyles: {
    '&:hover $notchedOutline': {
       borderColor: 'gold'
    },
    '&.Mui-focused $notchedOutline': {
      borderColor: 'gold'
    }
  },
});

export default function DetailsTextArea({detail, field, onFieldChange, isRequired, fieldIsStatic, getAllApprovalFieldsCount, isActuals, plannedFeature, isProject=false}) {
  const classes = useStyles();
  const [value, setValue] = useState('');

  const treatmentValidationUnsavedValues = useSelector((state) => { return state.treatmentValidation });
  const activityValidationUnsavedValues = useSelector((state) => { return state.activityValidation });
  const projectValidationUnsavedValues = useSelector((state) => { return state.projectValidation });
  const actualsTreatmentValidationUnsavedValues = useSelector((state) => { return state.actualsTreatmentValidation });
  const actualsActivityValidationUnsavedValues = useSelector((state) => { return state.actualsActivityValidation });

  useEffect(() => {
    if(detail && detail.attributes[field]){
      setValue(detail.attributes[field]);
    } else {
      setValue("");
    }
  }, [detail, field]);

  const inputValueMissing = () => {
    
    if(detail && detail.attributes){
      let isApproved;
      if(isActuals){
        isApproved = getAllApprovalFieldsCount ? getAllApprovalFieldsCount(plannedFeature, isRequired) : false;
      } else {
        isApproved = getAllApprovalFieldsCount ? getAllApprovalFieldsCount(detail, isRequired) : false;
      }
      if(!detail.attributes[field] && detail.attributes[FieldNames.featureFields.status] === FieldNames.statuses.cancelled && !isApproved){
        //Cancelled Here
        return true
      } else {
        //Not Cancelled Here
        return false
      }
    } else {
      //No details
      return false;
    }
  }
  const showClasses = () => {
    const isValMissing = inputValueMissing();
    if(!isActuals){
      if((isRequired && isValMissing) || 
        (detail && detail.attributes && field === FieldNames.featureFields.statusReason && detail.attributes[FieldNames.featureFields.status] === FieldNames.statuses.cancelled 
          && getAllApprovalFieldsCount && getAllApprovalFieldsCount(detail, isRequired) && !detail.attributes[FieldNames.featureFields.statusReason])
        ){
          return true;
        } else {
          return false;
        }
    } else {
      if((isRequired && isValMissing) || 
        (detail && detail.attributes && field === FieldNames.featureFields.statusReason && detail.attributes[FieldNames.featureFields.status] === FieldNames.statuses.cancelled 
          && !detail.attributes[FieldNames.featureFields.statusReason])
        ){
          return true;
        } else {
          return false;
        }
    }
  }

  const showNotSavedClasses = (field) => {
    var fieldState = false;
    if(isProject){
      if(detail?.attributes)
        {
          // Projects
          if(projectValidationUnsavedValues === null || !field || field.length === 0)
          {
            return false;
          }
          fieldState = projectValidationUnsavedValues[field];
        }
    } else {
      if(detail && detail.attributes[FieldNames.featureFields.class] === FieldNames.classTypes.treatment)
        {
          // Estimated Treatment
          if(treatmentValidationUnsavedValues === null || !field || field.length === 0)
          {
            return false;
          }
          fieldState = treatmentValidationUnsavedValues[field];
        }
        else if(detail && detail.attributes[FieldNames.featureFields.class] === FieldNames.classTypes.actualTreatment)
        {
          // Actual Treatment
          if(actualsTreatmentValidationUnsavedValues === null || !field || field.length === 0)
          {
            return false;
          }
          fieldState = actualsTreatmentValidationUnsavedValues[field];
        }
        else if(detail && detail.attributes[FieldNames.featureFields.class] === FieldNames.classTypes.activity)
        {
          // Estimated Activity
          if(activityValidationUnsavedValues === null || !field || field.length === 0)
          {
            return false;
          }
          fieldState = activityValidationUnsavedValues[field];
        }
        else if(detail && detail.attributes[FieldNames.featureFields.class] === FieldNames.classTypes.actualActivity)
        {
          // Actual Activity
          if(actualsActivityValidationUnsavedValues === null || !field || field.length === 0)
          {
            return false;
          }
          fieldState = actualsActivityValidationUnsavedValues[field];
        }
        else
        {
          return false;
        }
    }
    return fieldState;
    
  }

  return (
    <FormControl variant="standard" fullWidth>
    <ThemeProvider theme={theme}>
    <BasicTextField
        detail={detail}
        onFieldChange={onFieldChange}
        field={field}
        label=""
        value={value}
        setValue={setValue}
        variant={"outlined"}
        placeholder={""}
        useFullWidth={true}
        useMultiline={true}
        isDisabled={((fieldIsStatic || (getAllApprovalFieldsCount && getAllApprovalFieldsCount(detail, isRequired))) && detail && detail.attributes && detail.attributes[FieldNames.featureFields.status] !== FieldNames.statuses.cancelled)}
        inputProps={ {... (showClasses()) ? 
          {InputProps: { classes: { root: classes.root, notchedOutline: classes.notchedOutline } }} 
          : (showNotSavedClasses(field)) ? 
          {InputProps: { classes: { root: classes.notsavedstyles, notchedOutline: classes.notchedNotSavedOutline } }} 
          : { InputProps: {}}}}
          triggerEvent={Events.TriggerFieldChange}
      />
      </ThemeProvider>
    </FormControl>
  );
}